import PanelSearchResults from './PanelSearchResults';
export default PanelSearchResults;
